import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Column, Row, Button, Stack } from '@grubhubprod/gh-cookbook-react';
import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';
import { useCorpFormAutofill } from 'src/components/enterprise/features/Corporate/components/Form/hooks/useCorpFormAutofill';
import { getWindow } from 'src/utilities/window';

type CorporateFormFooterProps = {
  onSubmit: (data: CorporateFormFields) => void;
};

export const CorporateFormFooter: React.FC<CorporateFormFooterProps> = ({
  onSubmit,
}) => {
  const { handleSubmit, formState } = useFormContext<CorporateFormFields>();
  const { isValid, isSubmitting } = formState;
  const { isEditPage, isParentPage } = useCorporateFormContext();
  const { handleAutofillForm, shouldShowAutofillButton } =
    useCorpFormAutofill();
  const window = getWindow();

  const renderButtonText = (): string => {
    if (isEditPage) {
      return 'Update Client';
    }
    if (isParentPage) {
      return 'Create parent account';
    }
    return 'Add New Client';
  };

  return (
    /* Add padding at the bottom to prevent dropdowns from causing screen jumps or unexpected movement */
    <Stack y="xxx-lg">
      <Row gutter={8}>
        <Column gutter={8} phone={3}>
          <Button
            block
            type="button"
            isLoading={isSubmitting}
            disabled={!isValid || isSubmitting}
            variant="primary"
            buttonSize="medium"
            onClick={handleSubmit(onSubmit)}
          >
            {renderButtonText()}
          </Button>
        </Column>
        <Column gutter={8} phone={3}>
          <Button
            block
            type="button"
            variant="secondary"
            buttonSize="medium"
            onClick={(): void => {
              window.location.href = `${window.location.origin}/groupadmin/corps`;
            }}
          >
            Cancel
          </Button>
        </Column>
        {shouldShowAutofillButton && (
          <Column gutter={8} phone={3}>
            <Button
              block
              type="button"
              variant="secondary"
              buttonSize="medium"
              onClick={handleAutofillForm}
            >
              Autofill
            </Button>
          </Column>
        )}
      </Row>
    </Stack>
  );
};
